import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';

import {
    RELATIONSHIP_SET_VALUE,
    RELATIONSHIP_SET_VALID,
    NAME_SET_VALUE,
    NAME_SET_VALID,
    ID_BIRTH_CERTIFICATE_SET_VALUE,
    ID_BIRTH_CERTIFICATE_SET_VALID,
    DATE_OF_ONSET_SET_VALUE,
    DATE_OF_ONSET_SET_VALID,
    DATE_OF_LAST_EPISODE_SET_VALUE,
    DATE_OF_LAST_EPISODE_SET_VALID,
    PAST_CURRENT_TREATMENT_SET_VALUE,
    PAST_CURRENT_TREATMENT_SET_VALID,
    ADDITIONAL_DETAILS_SET_VALID,
    ADDITIONAL_DETAILS_SET_VALUE,
    ADD_MEDICAL_HISTORY,
    UPDATE_MEDICAL_HISTORY,
    DELETE_MEDICAL_HISTORY,
    FORM_VALID_AFYA_IMARA_MEDICAL_HISTORY_NEXT_OF_KIN_FORM,
    FORM_INVALID_AFYA_IMARA_MEDICAL_HISTORY_NEXT_OF_KIN_FORM,
    REINITIALIZE,
    DIAGNOSIS_SET_VALUE,
    DIAGNOSIS_SET_VALID,
    RESET_FORM,
    NONE_OF_THE_ABOVE_SET_VALUE,
    NONE_OF_THE_ABOVE_SET_VALID,
    API_PENDING_TRANSITION_MEDICAL_HISTORY_FORM,
    API_SUCCESS_TRANSITION_MEDICAL_HISTORY_FORM,
    API_FAILURE_TRANSITION_MEDICAL_HISTORY_FORM,
    API_INITIAL_TRANSITION_MEDICAL_HISTORY_FORM
} from '../../actions/afyaImara/medicalHistory';


export const initMedicalHistory = {
    formStatus: FORM_STATUS.INVALID,
    dropOffDetails: null,
    nextOfKinReferenceData: null,
    apiCallStatus: null,
    medicalHistory: [],
    form: {
        relationship: {value: null, error: null, status: null},
        name: {value: null, error: null, status: null},
        idBirthCertificate: {value: null, error: null, status: null},
        dateOfOnset: {value: null, error: null, status: null},
        dateOfLastEpisode: {value: null, error: null, status: null},
        pastCurrentTreatment: {value: null, error: null, status: null},
        additionalDetails: {value: null, error: null, status: null},
        diagnosis: {value: null, error: null, status: null},
        noneOfTheAbove: {value: false, error: null, status: null},
    }
};

export default (state = initMedicalHistory, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case FORM_VALID_AFYA_IMARA_MEDICAL_HISTORY_NEXT_OF_KIN_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_AFYA_IMARA_MEDICAL_HISTORY_NEXT_OF_KIN_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case API_PENDING_TRANSITION_MEDICAL_HISTORY_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };
        case API_SUCCESS_TRANSITION_MEDICAL_HISTORY_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_TRANSITION_MEDICAL_HISTORY_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };
        case API_INITIAL_TRANSITION_MEDICAL_HISTORY_FORM:
            return { ...state, apiCallStatus: null };
        case RELATIONSHIP_SET_VALUE:
            return updateFormField('relationship', (field) => ({
                ...field,
                value: action.value,
            }));

        case RELATIONSHIP_SET_VALID:
            return updateFormField('relationship', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case NAME_SET_VALUE:
            return updateFormField('name', (field) => ({
                ...field,
                value: action.value,
            }));
        case NAME_SET_VALID:
            return updateFormField('name', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_BIRTH_CERTIFICATE_SET_VALUE:
            return updateFormField('idBirthCertificate', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_BIRTH_CERTIFICATE_SET_VALID:
            return updateFormField('idBirthCertificate', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case DATE_OF_ONSET_SET_VALUE:
            return updateFormField('dateOfOnset', (field) => ({
                ...field,
                value: action.value,
            }));

        case DATE_OF_ONSET_SET_VALID:
            return updateFormField('dateOfOnset', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case DATE_OF_LAST_EPISODE_SET_VALUE:
            return updateFormField('dateOfLastEpisode', (field) => ({
                ...field,
                value: action.value,
            }));

        case NONE_OF_THE_ABOVE_SET_VALUE:
            return updateFormField('noneOfTheAbove', (field) => ({
                ...field,
                value: action.value,
            }));


        case NONE_OF_THE_ABOVE_SET_VALID:
            return updateFormField('noneOfTheAbove', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case DATE_OF_LAST_EPISODE_SET_VALID:
            return updateFormField('dateOfLastEpisode', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case PAST_CURRENT_TREATMENT_SET_VALUE:
            return updateFormField('pastCurrentTreatment', (field) => ({
                ...field,
                value: action.value,
            }));

        case PAST_CURRENT_TREATMENT_SET_VALID:
            return updateFormField('pastCurrentTreatment', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case DIAGNOSIS_SET_VALUE:
            return updateFormField('diagnosis', (field) => ({
                ...field,
                value: action.value,
            }));

        case DIAGNOSIS_SET_VALID:
            return updateFormField('diagnosis', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ADDITIONAL_DETAILS_SET_VALUE:
            return updateFormField('additionalDetails', (field) => ({
                ...field,
                value: action.value,
            }));
        case ADDITIONAL_DETAILS_SET_VALID:
            return updateFormField('additionalDetails', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case ADD_MEDICAL_HISTORY:
            return {
                ...state,
                medicalHistory: [...state.medicalHistory, action.value],
            };
        case UPDATE_MEDICAL_HISTORY:
            return {
                ...state,
                medicalHistory: state.medicalHistory.map((item, index) =>
                    index === action.index ? action.value : item
                ),
            };
        case DELETE_MEDICAL_HISTORY:
            return {
                ...state,
                medicalHistory: state.medicalHistory.filter((item, index) => index !== action.index),
            };

        

        // Reset Form
        case RESET_FORM:
            return {
                ...state,
                form: initMedicalHistory.form,
                formStatus: FORM_STATUS.INVALID,
            };
        // Reset the state
        case REINITIALIZE:
            return initMedicalHistory;

        
        default:
            return state;
    }
};
